import { httpPost, httpPatchMerge, httpPatch, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IOpportunityTeamMember } from '~/types/opportunity/models'

const apiEntityPath = '/api/opportunityteammembers'

export async function createOpportunityTeamMember(
  entity: IOpportunityTeamMember
) {
  const callingMn = createOpportunityTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityTeamMember>({
    callingMn,
    apiPath,
    entity,
  })
}

// export async function updateOpportunityTeamMember(
//   entityData: Partial<IOpportunityTeamMember>,
//   id: TEntityId
// ) {
//   const callingMn = updateOpportunityTeamMember.name
//   const apiPath = `${apiEntityPath}/${id}`
//   type TPartialOpportunityTeamMember = Partial<IOpportunityTeamMember>
//   return httpPatchMerge<TPartialOpportunityTeamMember>({
//     callingMn,
//     apiPath,
//     entityData,
//   })
// }

export async function updateOpportunityTeamMember(
  entityData:
    | Partial<IOpportunityTeamMember>
    | Partial<IOpportunityTeamMember>[],
  id: TEntityId
) {
  const callingMn = updateOpportunityTeamMember.name
  if (Array.isArray(entityData)) {
    const apiPath = `${apiEntityPath}`
    return httpPatch<Partial<IOpportunityTeamMember>[]>({
      callingMn,
      apiPath,
      entityData,
    })
  }
  const apiPath = `${apiEntityPath}/${id}`
  return httpPatchMerge<Partial<IOpportunityTeamMember>>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOpportunityTeamMember(
  entityData: IOpportunityTeamMember
) {
  const callingMn = deleteOpportunityTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<IOpportunityTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}
